import { Attributes, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../../Common/TextConstants";

@NeoModel
export default class TransactionSearchCriteria extends ValueObject {

    @Rules.Required()
    public staticServiceProviderFileGroupingID: number = 0;

    public rawAccountNumber: string = "";

    public clientAccountNumber: string = "";

    public serviceProviderGroupingName: string | null = null;

    public instrument: string = "";

    public instrumentID: number | null = null;

    public isinCode: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeEndDate: Date | null = null;

    addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    
        rules.failWhen(c => (c.rangeStartDate === null) , TextConstants.Validation.ProvideStartDate);

        rules.failWhen(c => (c.rangeEndDate === null) , TextConstants.Validation.ProvideEndDate);
    }
}